import {
    VRCORE_GET_USERS,
    VRCORE_PROFILE_EDIT_SELECTED_USER_UID,
    VRCORE_PROFILE_EDIT_SELECTED_TAB,
    VRCORE_POST_EDITED_USER,
    VRCORE_GET_QUALIFICATIONS,
    VRCORE_REMOVE_IMAGE,
    VRCORE_UPLOAD_IMAGE
} from "./types";

const INITIAL_STATE = {
    requesting: false,
    users: false,
    selectedUserUID: 0,
    uploadedImage: "",

    selectedTab: "general",
    qualificationList: false
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case VRCORE_GET_QUALIFICATIONS.REQUEST: {
            return { ...state, requesting: true, qualificationList: false };
        }
        case VRCORE_GET_QUALIFICATIONS.FAIL: {
            return { ...state, requesting: false, qualificationList: false };
        }
        case VRCORE_GET_QUALIFICATIONS.SUCCESS: {
            return {
                ...state,
                requesting: false,
                qualificationList: action.payload
            };
        }
        case VRCORE_GET_USERS.REQUEST: {
            return { ...state, requesting: true, users: false };
        }
        case VRCORE_GET_USERS.SUCCESS: {
            return { ...state, requesting: false, users: action.payload };
        }
        case VRCORE_GET_USERS.FAIL: {
            return { ...state, requesting: false, users: false };
        }
        case VRCORE_PROFILE_EDIT_SELECTED_USER_UID: {
            return { ...state, selectedUserUID: action.payload };
        }
        case VRCORE_PROFILE_EDIT_SELECTED_TAB: {
            return { ...state, selectedTab: action.payload };
        }
        case VRCORE_POST_EDITED_USER.REQUEST: {
            return { ...state, requesting: true };
        }
        case VRCORE_POST_EDITED_USER.SUCCESS: {
            return { ...state, requesting: false };
        }
        case VRCORE_POST_EDITED_USER.FAIL: {
            return { ...state, requesting: false };
        }
        case VRCORE_UPLOAD_IMAGE.REQUEST: {
            return { ...state, requesting: true };
        }
        case VRCORE_UPLOAD_IMAGE.SUCCESS: {
            return {
                ...state,
                requesting: false
            };
        }
        case VRCORE_UPLOAD_IMAGE.FAIL: {
            return { ...state, requesting: false };
        }
        case VRCORE_REMOVE_IMAGE.REQUEST: {
            return { ...state, requesting: true };
        }
        case VRCORE_REMOVE_IMAGE.SUCCESS: {
            return { ...state, uploadedFiles: "", requesting: false };
        }
        case VRCORE_REMOVE_IMAGE.FAIL: {
            return { ...state, removed: false, requesting: false };
        }
        default: {
            return state;
        }
    }
};
